import { Component } from '@angular/core';

@Component({
  selector: 'app-save-success-modal',
  templateUrl: './save-success-modal.component.html',
  styleUrls: ['./save-success-modal.component.scss']
})
export class SaveSuccessModalComponent {
  
}
